import { Component, OnInit } from '@angular/core';
import { NavigationService } from '../../shared/services/navigation.service';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-step-indicator',
  templateUrl: './step-indicator.component.html',
  styleUrls: ['./step-indicator.component.css']
})
export class StepIndicatorComponent implements OnInit {
  public currentStep = 0;
  public steps: any;

  constructor(private navigationService: NavigationService, private route: ActivatedRoute) {
    this.navigationService.stepChangedAnnounced.subscribe(stepNumber => {
      this.currentStep = stepNumber;
    });

    if (this.route && this.route.data) {
      this.route.data.subscribe(val => {
        if (val && val.steps) {
          this.steps = val.steps;
        }
      });
    }
  }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/layout/step-indicator/step-indicator.component.ts